import React, { useState } from 'react';

const ClearCacheButton = () => {
  const [isClearing, setIsClearing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const clearCache = async () => {
    setIsClearing(true);
    
    try {
      // الطريقة 1: استخدام الدالة الموجودة
      if (window.clearCaches) {
        window.clearCaches();
      } 
      // الطريقة 2: مسح يدوي
      else {
        // مسح كل الكاشات
        const cacheNames = await caches.keys();
        const zoneCaches = cacheNames.filter(name => name.includes('zone-'));
        
        await Promise.all(zoneCaches.map(name => caches.delete(name)));
        
        // إلغاء تسجيل Service Worker
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(reg => reg.unregister()));
        
        // إشعار المستخدم
        alert('✅ تم مسح الكاش بنجاح، سيتم إعادة التشغيل');
        
        // إعادة تحميل الصفحة
        window.location.reload();
      }
    } catch (error) {
      console.error('❌ فشل مسح الكاش:', error);
      alert('حدث خطأ أثناء مسح الكاش');
    } finally {
      setIsClearing(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      {/* زر المسح العادي */}
      <button
        onClick={() => setShowConfirm(true)}
        disabled={isClearing}
        style={{
          padding: '8px 16px',
          background: '#ffc107',
          color: '#000',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          margin: '5px',
          opacity: isClearing ? 0.5 : 1
        }}
      >
        {isClearing ? 'جاري المسح...' : 'مسح الكاش'}
      </button>

      {/* نافذة تأكيد */}
      {showConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '400px',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 15px 0' }}>⚠️ تأكيد مسح الكاش</h3>
            <p style={{ margin: '0 0 20px 0' }}>
              هل أنت متأكد من مسح الكاش؟<br />
              <small style={{ color: '#666' }}>
                سيتم مسح جميع البيانات المخزنة وإعادة تشغيل التطبيق
              </small>
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                onClick={clearCache}
                style={{
                  padding: '8px 20px',
                  background: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                نعم، مسح الكاش
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                style={{
                  padding: '8px 20px',
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClearCacheButton;